<template>
  <tr class="car-row">
    <td>
      <div class="text-center">
        <img style="max-height: 50px; max-width: 75px;" :src="carImage"/>
      </div>
    </td>
    <td>
      <div class="text-center">
        <router-link :to="`/fleet/vehicles/${car.uuid}`">
        #{{ car.convadisId }}
        </router-link>
      </div>
    </td>
    <td>
      <div class="text-center">
        <router-link :to="`/fleet/vehicles/${car.uuid}`">
        {{ car.name }}
        </router-link>
      </div>
    </td>
    <td>
      <div class="text-center">
        <router-link :to="`/fleet/vehicles/${car.uuid}`">
        {{ car.rego }}
        </router-link>
      </div>
    </td>
    <td>
      <div class="text-center">
        {{ car.CarType.name }}
      </div>
    </td>
    <td>
      <a v-if="car.Lot" target="_blank" :href="googleLink">
        <span class="fa fa-map-marker-alt fa-fw"></span> {{ car.Lot.address }}
      </a>
      <label class="label label-danger" v-else>Car not on lot</label>
    </td>
    <td>
      <div class="text-center">
        {{ car.lastVoltageReading ? car.lastVoltageReading : 'N/A' }}
      </div>
    </td>
    <td>
      <div class="text-center">
        <router-link v-if="car.Reservations[0]" :to="{ path: '/fleet/reservations/' + car.Reservations[0].uuid }">
           # {{ car.Reservations[0].reservationId }}
        </router-link>
        <em v-else>n/a</em>
      </div>
    </td>
    <td>
      <dropdown-input label="Actions"
        label-icon="fa-car"
        :actions="carActions(car)"
        :dropup="true"
        @action="executeAction($event, car)">
      </dropdown-input>
    </td>
  </tr>
</template>

<script>
import DropdownInput from '@/components/inputs/DropdownInput'
import { mapActions, mapGetters } from 'vuex'
import {
  INSTANT_RESERVATION,
  UNLOCK_CAR,
  LOCK_CAR,
  IGNITION_ON,
  IGNITION_OFF,
  IMMOBILIZE_VEHICLE,
  GPS_LOCATION,
  NEW_RESERVATION,
  NEW_MAINTENANCE,
  EDIT_CAR,
  MOVE_CAR,
  REPORT_DAMAGE,
  ADD_CAR_NOTE,
  TRIP_DATA
} from '@/vuex/types'

export default {
  components: {
    DropdownInput
  },
  name: 'CarRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    carImage () {
      return 'https://techcar-dev.s3.amazonaws.com/' +
      this.car.CarType.AmazonImage.objectKey
    },
    googleLink () {
      if (this.car.Lot) {
        return 'https://maps.google.com/?q=' +
        this.car.Lot.latitude + ',' +
        this.car.Lot.longitude
      }
    },
    car () {
      return {
        CarType: {
          AmazonImage: {
            objectKey: 'spacer.gif'
          }
        },
        Lot: {},
        Reservations: [],
        AccountNotes: [],
        ...this.object,
        ...this.updatedCar
      }
    },
    ...mapGetters([
      'carCommands',
      'carActions'
    ])
  },
  data () {
    return {
      updatedCar: {}
    }
  },
  methods: {
    async executeAction (action, payload) {
      let result = await this[action](payload)
      if (result && result.updated) this.updatedCar = result.updated
    },
    ...mapActions([
      INSTANT_RESERVATION,
      UNLOCK_CAR,
      LOCK_CAR,
      IGNITION_ON,
      IGNITION_OFF,
      IMMOBILIZE_VEHICLE,
      GPS_LOCATION,
      NEW_RESERVATION,
      NEW_MAINTENANCE,
      EDIT_CAR,
      MOVE_CAR,
      REPORT_DAMAGE,
      ADD_CAR_NOTE,
      TRIP_DATA
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/Car.vue